var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-weight-medium text-body text-grey-8 q-mb-sm full-width"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }